import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ToastService {
    private showFailureSubject = new BehaviorSubject<boolean>(false);
    private showSuccessSubject = new BehaviorSubject<boolean>(false);
    private showWarningSubject = new BehaviorSubject<boolean>(false);
    showFailure$ = this.showFailureSubject.asObservable();
    showSuccess$ = this.showSuccessSubject.asObservable();
    showDownloadEmpty$ = this.showWarningSubject.asObservable();

    setShowFailure(value: boolean) {
        this.showFailureSubject.next(value)
    }

    setShowWarning(value: boolean) {
        this.showWarningSubject.next(value)
    }

    setShowSuccess(value: boolean) {
        this.showSuccessSubject.next(value)
    }
}